import stockApi from 'src/services/StockApi'
import { resultToSuccess, resultToFailed, optionsFor } from '../Helper'
import dayjs from 'dayjs'

export const getDivegencesReceivement = async (badge, receivementId) => {
  try {
    const responseSuccess = await stockApi.get(
      `/v2/recebimento/${receivementId}/divergencias`,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const getBarcodeNotFound = async (badge, receivementId) => {
  try {
    const responseSuccess = await stockApi.get(
      `/v2/recebimento/${receivementId}/barcodes-nao-encontrados`,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const postCalculateDivergence = async (badge, receivementId) => {
  try {
    const responseSuccess = await stockApi.post(
      `/v2/recebimento/${receivementId}/divergence/create`,
      null,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const closeDivergence = async (badge, receivementId) => {
  try {
    const responseSuccess = await stockApi.post(
      `/v2/recebimento/${receivementId}/divergence/close`,
      null,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const getOrderItems = async (badge: string, receivementId: string | number) => {
  try {
    const responseSuccess = await stockApi.get(
      `/v2/recebimento/${receivementId}/order-items`,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const getDivergentProducts = async (badge, receivementId) => {
  try {
    const responseSuccess = await stockApi.get(
      `/v2/recebimento/${receivementId}/divergences`,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const updateBatchWithoutProduct = async (badge, idBatch, order) => {
  try {
    const responseSuccess = await stockApi.patch(
      `/v2/recebimento/lote/${idBatch}/update-product`,
      order,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const updateBatchCount = async (
  badge,
  idBatch,
  totalQuantity,
  damageType,
  damageQuantity,
) => {
  try {
    const responseSuccess = await stockApi.patch(
      `/v2/recebimento/lote/${idBatch}/update-count`,
      {
        total_quantity: totalQuantity,
        damage_type: damageType,
        damage_quantity: damageQuantity,
      },
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}

export const insertBatchsNotReceived = async ({
  batchId,
  productDivergenceId,
  batchesNotReceived,
  badge,
}) => {
  try {
    const data = batchesNotReceived.map((batches) => ({
      total_qty: batches.total,
      expiration_date: dayjs(batches.expirationDate).format('YYYY-MM-DD'),
      damage_type: batches.damageType,
      damage_qty: batches.damageQty,
    }))

    const responseSuccess = await stockApi.post(
      `/v2/recebimento/batch/add-not-received/${productDivergenceId}/${batchId}`,
      data,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    throw resultToFailed(responseFailed)
  }
}

export const confirmBatchNotReceived = async ({
  batchId,
  productDivergenceId,
  badge,
}) => {
  try {
    const responseSuccess = await stockApi.post(
      `/v2/recebimento/batch/confirm-not-received/${productDivergenceId}/${batchId}`,
      null,
      optionsFor(badge),
    )
    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    throw resultToFailed(responseFailed)
  }
}

export const recountValidateUser = async (
  batchId: number,
  badge: string,
) => {
  try {
    const responseSuccess = await stockApi.post(
      `/v2/recebimento/lote/${batchId}/recount/validate-user`,
      null,
      optionsFor(badge),
    )

    return resultToSuccess(responseSuccess)
  } catch (responseFailed) {
    return resultToFailed(responseFailed)
  }
}
